export default class FantasyCoefficientsModel {
  public assists: number = null;
  public shots: number = null;
  public offsides: number = null;
  public tackles: number = null;
  public saves: number = null;
  public minutesEqualOrOver60: number = null;
  public minutesUnder60: number = null;
  public yellowCards: number = null;
  public redCards: number = null;
  public goalsGoalkeeper: number = null;
  public goalsDefender: number = null;
  public goalsMidfielder: number = null;
  public goalsForwards: number = null;
  public penaltyGoals: number = null;
  public ownGoals: number = null;
  public cleanSheetsGoalkeeper: number = null;
  public cleanSheetsDefender: number = null;
  public cleanSheetsMidfielder: number = null;
  public cleanSheetsForwards: number = null;
  public shotsOn: number = null;
  public foulsCommitted: number = null;
  public penaltyCommitted: number = null;
  public penaltyWon: number = null;
  public penaltyMissed: number = null;
  public concededGoals: number = null;
  public caughtBall: number = null;
}
